export default {
  isFetching: false,
  objectUrl: null,
};
